import { render, staticRenderFns } from "./CryptoPaymentPanel.vue?vue&type=template&id=70609960&"
import script from "./CryptoPaymentPanel.vue?vue&type=script&lang=js&"
export * from "./CryptoPaymentPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports